import logger from '@/layers/support/monitoring/logger';
import { ProviderProfile } from '@/types/models';

const LOG_MODULE = 'FE [Presentation / Utils / profileUtils]';

/**
 * Checks if a provider profile requires completion
 * @param providerProfile The provider profile to check
 * @returns Boolean indicating if profile needs completion
 */
export function providerProfileNeedsCompletion(providerProfile: ProviderProfile | null): boolean {
  if (!providerProfile) {
    return false;
  }

  // Check both regular fields (for backward compatibility) and meta fields
  const hasNpi = !!providerProfile.npi || !!providerProfile.meta?.npi;
  const hasAcknowledgement = !!providerProfile.meta?.acknowledgement;

  const needsCompletion = !hasNpi || !hasAcknowledgement;

  logger.debug(`${LOG_MODULE} Provider profile completion check`, {
    needsCompletion,
    hasNpi,
    hasAcknowledgement,
    usesMetaFields: {
      npi: !!providerProfile.meta?.npi,
      acknowledgement: !!providerProfile.meta?.acknowledgement,
    },
  });

  return needsCompletion;
}
